import { useEffect, useState } from 'react'

/**
 * Returns the remaining seconds for a timer started at `startedAt` with `durationSeconds`.
 * Returns null if the timer is already completed or durationSeconds is not set.
 */
export function useTimerCountdown(startedAt: string | null, durationSeconds: number | null): number | null {
  const [remaining, setRemaining] = useState<number | null>(null)

  useEffect(() => {
    if (!startedAt || durationSeconds == null) {
      setRemaining(null)
      return
    }

    const compute = () => {
      const elapsed = Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000)
      return Math.max(0, durationSeconds - elapsed)
    }

    setRemaining(compute())
    const interval = setInterval(() => {
      const remaining = compute()
      setRemaining(remaining)
      if (remaining <= 0) {
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [startedAt, durationSeconds])

  return remaining
}

export function formatCountdown(seconds: number): string {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}
